import { elementReady } from '../utilities';
import { nanoid } from 'nanoid/non-secure';

window.dataLayer = window.dataLayer || [];

const marker = [10, 25, 50, 75, 90, 100];
const timeStamps = new Array();

const pushVideoTag = (event) => {
	const t = event.target;
	const percentage = Math.floor((t.currentTime / t.duration) * 100);
	const length = Math.floor(t.duration);
	const seconds = Math.floor(t.currentTime);

	// Send progress updates to GTM only when certain ranges are reached.
	for (let i = marker.length - 1; i >= 0; i--) {
		const m = marker[i];

		if (percentage >= m) {
			if (!timeStamps[t.id].includes(m)) {
				timeStamps[t.id].push(m);

				const attributes = {
					event: 'videoInternalProgress',
					video: {
						source: t.currentSrc,
						length,
						progress: {
							percent: m,
							seconds,
						},
					},
				};

				if (t.dataset?.video) {
					attributes.name = t.dataset.video;
				}

				window.dataLayer.push(attributes);
			}

			break;
		}
	}
};

const init = (video) => {
	if (!video.id) {
		video.id = 'video-' + nanoid();
	}

	timeStamps[video.id] = new Array();
	video.addEventListener('timeupdate', pushVideoTag);
};

elementReady('video').then((video) => {
	if (video instanceof NodeList) {
		video.forEach((v) => {
			init(v);
		});
	} else {
		init(video);
	}
});
